import Userback from '@userback/widget'

const Boot = async ({ app }) => {
  if (import.meta.env.DEV) {
    return
  }

  try {
    // I think userback expects to be initialized BEFORE the app is mounted, and
    // even suggests creating the app inside the resolve callback, which is
    // insane - anything goes wrong with UB and the app is dead in the water.
    // What is it with non-critical third party libraries that want to be
    // the the centre of everything.

    // For now. this seems to work as long as we use the project ID, not
    // the global access ID.

    // And DO NOT await this - if anything goes wrong at the other end, it
    // never resolves and hangs the app before it can boot.
    Userback('P-MBdSsleUe8h95VODFeW0W0Y7O', {})
      .then((userback) => {
        app.config.globalProperties.$userback = userback
        console.debug('Userback widget initialized successfully')
      })
      .catch((error) => {
        console.error('Error loading Userback widget:' + error.message)
        console.log(error)
      })
  } catch (error) {
    console.error('Failed to initialize Userback:', error)
  }
}

export default Boot
